import { OnboardingTooltip } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { useOnboardingCookie, useOnboardingState } from './hooks';
import { ROUTE_TAB_INDEX_C, selectRouteMapTabPosition } from '../../selectors/selectRouteMapTabPosition';

interface IRoutetabOnboardingContainerProps {
  children: React.ReactElement;
}

export const RouteTabOnboarindContainer: React.FC<React.PropsWithChildren<IRoutetabOnboardingContainerProps>> = ({
  children,
}) => {
  const routeTabIndex = useSelector(selectRouteMapTabPosition);

  const { containerRef, onboardingIsAvailable } = useOnboardingCookie();
  const [onboardingIsOpen, closeOnboarding] = useOnboardingState(onboardingIsAvailable);

  return (
    <div ref={containerRef} style={{ order: routeTabIndex }}>
      <OnboardingTooltip
        open={routeTabIndex === ROUTE_TAB_INDEX_C && onboardingIsAvailable && onboardingIsOpen}
        onClose={closeOnboarding}
        content="Добавьте адрес работы или школы и смотрите, сколько добираться до них от любого объекта"
        header="Стройте маршруты на карте"
        placement="right"
      >
        {children}
      </OnboardingTooltip>
    </div>
  );
};
